import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true, timeout: 30000 });

const readCookie = (name) =>
  document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1];

export async function ensureCsrf() {
  if (!readCookie("ma_csrf")) await api.get("/auth/csrf");
}

api.interceptors.request.use((config) => {
  const tok = readCookie("ma_csrf");
  if (tok) config.headers["X-CSRF-Token"] = tok;
  return config;
});

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.response?.status === 429 ? "Troppe richieste, riprova più tardi." : "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => String(d.msg || "").replace(/^Value error, /, "")).join(" · ");
  return String(detail);
}

export const mediaUrl = (id, size = "md") => (id ? `${API_BASE}/public/media/${id}/${size}` : null);
export const privateMediaUrl = (id) => `${API_BASE}/admin/media/${id}/original`;
